import { Validations } from 'belle-js'
const { matchRegexp } = Validations

const isExisty = function (value) {
  return value !== null && value !== undefined
}

const isEmpty = function (value) {
  return value === ''
}

const dateMinimum = new Date('01/01/1900')

// Note: validations should always accept empty/blank values.
// Requiredness should be controlled by
// the formfields themselves.

export const isValidStartingDate = (values, value) => {
  const date = new Date(value)
  return !isExisty(value) || isEmpty(value) || date > dateMinimum
}

export const isValidFundName = (_, value = '') => {
  const fundNameRegEx = new RegExp('\\btrust\\b')
  return value && !fundNameRegEx.test(value.toLowerCase())
}

export const isNotFutureDate = (_, value) => {
  if (!value) return true
  const date = new Date(value)
  const today = new Date()
  return today > date
}

export const isBirthdateMatch = (values, value) => values.personBirthdate === value

export const isDonorDobMatch = (values, value) => values.donorDateOfBirth === value

export const isDeceasedDobMatch = (values, value) => values.deceasedDob === value

export const isMinorDobMatch = (values, value) => values.minorDateOfBirth === value

export const isValidAge = (values, value) => {
  const date = new Date(value)
  return !isExisty(value) || isEmpty(value) || date < new Date()
}

export const isValidExpirationDate = (values, value) => {
  const date = new Date(value)
  const today = new Date()
  return !isExisty(value) || isEmpty(value) || date > today
}

export const isValidTrustDate = (values, value) => {
  const date = new Date(value)
  const today = new Date()
  return !isExisty(value) || isEmpty(value) ||
    (date > dateMinimum && date.setHours(0,0,0,0) < today.setHours(0,0,0,0))
}

export const isValidFutureDate = (values, value) => {
  const date = new Date(value)
  const dateYear = date.getFullYear()
  const yearsInTheFuture = dateYear - new Date().getFullYear()
  return !isExisty(value) || isEmpty(value) || yearsInTheFuture <= 100
}

export const isValidPrimaryAddress = (values, value) => {
  const poBox = /^ *((#\d+)|((box|bin)[-. /\\]?\d+)|(.*p[ .]? ?(o|0)[-. /\\]? *-?((box|bin)|b|(#|num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num|#)? *\d+|(num|number|#) *\d+)/i
  return !isExisty(value) || isEmpty(value) || !poBox.test(value)
}

export const isValidPersonName = (values, value) => {
  const nameRegex = /^[a-zA-Z'\s.-]{0,150}$/
  return matchRegexp(values, value, nameRegex)
}

export const isValidNameWithNumber = (values, value) => {
  const trustRegex = /^[0-9a-zA-Z'\s.-]{0,150}$/
  return matchRegexp(values, value, trustRegex)
}

export const isValidEntityName = (values, value) => {
  const nameRegex = /^[a-zA-Z'\s.]{0,150}$/
  return matchRegexp(values, value, nameRegex)
}

export const isValidPositivePercentage = (values, value) => (parseFloat(value) > 0)

export const isValidPostalCode = (values, value) => {
  const postalCodeRegex = /^[a-zA-Z0-9-]{0,150}$/
  return matchRegexp(values, value, postalCodeRegex)
}

export const isValidSocialSecurityNumber = (values, value) => {
  const socialSecurityRegex = /^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$/
  return matchRegexp(values, value, socialSecurityRegex)
}

export const isValidMaskedSocialSecurityNumber = (values, value) => {
  const socialSecurityRegex = /^(\*{3}-?\*{2}-?\*{4})$/
  return matchRegexp(values, value, socialSecurityRegex)
}

export const isValidSsnMatch = (values, value) => {
  const match = values.ssn === value
  return match
}

export const isValidDeceasedSsnMatch = (values, value) => values.deceasedSsn === value

export const isValidDonorSsnMatch = (values, value) => 
  values.donorSocialSecurityNumber === value

export const isValidMinorSsnMatch = (values, value) => values.minorSsn === value

export const isValidPhoneNumber = (values, value) => {
  const phoneRegex = /^(\(\d{3}\) ?\d{3}-?\d{4}|XXX XXX-XXXX)$/
  return matchRegexp(values, value, phoneRegex)
}

export const isValidIdentificationNumber = (values, value) => {
  const numberRegex = /^[a-zA-Z0-9\s]{0,150}$/
  return matchRegexp(values, value, numberRegex)
}

export const isValidTaxIdNumber = (values, value) => {
  const numberRegex = /^[0-9-]*$/
  return matchRegexp(values, value, numberRegex)
}

export const isValidEmployerIdNumber = (values, value) => {
  const employerIDRegex = /^[ A-Za-z0-9_\-.\s]*$/
  return matchRegexp(values, value, employerIDRegex)
}

export const isValidIncomeTaxDate = (values, value) => {
  const incomeTaxRegex = /^(0?[1-9]|1[012])\/(0?[1-9]|[12]\d|3[01])$/
  return matchRegexp(values, value, incomeTaxRegex)
}

export const isValidPercentage = (values, value) => {
  const  percentageRegex = /^(\d\d?(\.\d\d?)?|100(\.00?)?)$/
  return matchRegexp(values, value, percentageRegex)
}

export const isValidCurrencyNumber = (values, value) => {
  const  decimalRegex = /^(?:\d+)(?:(?:\d+)|(?:(?:,\d+)?))+(\.\d{1,2})?\s*$/
  return matchRegexp(values, value, decimalRegex)
}

export const isValidDate = (values, value) => {
  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
  return matchRegexp(values, value, dateRegex)
}

export const isValidYear = (values, value) => {
  const dateRegex = /^(19|20)\d{2}$/
  return matchRegexp(values, value, dateRegex)
}

export const allValidations = {
  isValidStartingDate,
  isValidExpirationDate,
  isValidFutureDate,
  isValidPrimaryAddress,
  isValidEntityName,
  isValidPostalCode,
  isValidSocialSecurityNumber,
  isValidSsnMatch,
  isValidDeceasedSsnMatch,
  isValidMaskedSocialSecurityNumber,
  isValidPhoneNumber,
  isValidIdentificationNumber,
  isValidPersonName,
  isValidNameWithNumber,
  isValidAge,
  isValidEmployerIdNumber,
  isValidIncomeTaxDate,
  isValidPercentage,
  isValidCurrencyNumber,
  isValidPositivePercentage,
  isValidYear,
  isValidDate,
  isValidTrustDate,
  isValidTaxIdNumber,
  isBirthdateMatch,
  isDeceasedDobMatch,
  isNotFutureDate,
  isMinorDobMatch,
  isValidMinorSsnMatch,
  isDonorDobMatch,
  isValidFundName,
  isValidDonorSsnMatch,
}



// WEBPACK FOOTER //
// ./src/utils/fieldValidationRules.js